"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayTypeParam = exports.FormulaFunc = exports.getBlankValueByType = exports.FormulaBaseError = void 0;
const types_1 = require("../../types");
// Equation error base class, error reporting mechanism for unified equations
class FormulaBaseError extends Error {
    constructor(message) {
        super();
        this.message = message ? '#Error: ' + message : '#Error!';
    }
}
exports.FormulaBaseError = FormulaBaseError;
const getBlankValueByType = function (type, value) {
    if (value == null) {
        return null;
    }
    switch (type) {
        case types_1.BasicValueType.Number: {
            return 0;
        }
        case types_1.BasicValueType.String: {
            return '';
        }
        case types_1.BasicValueType.Boolean: {
            return false;
        }
        default: {
            return null;
        }
    }
};
exports.getBlankValueByType = getBlankValueByType;
class FormulaFunc {
    /**
     * The function needs to check the parameter type and number in the stage of parsing the AST tree.
     * If it does not meet the needs of the function, directly throw new Error and bring a friendly prompt
     * Error throwing principle:
     * 1. If there are fewer required parameters, an error will be thrown, and if there are too many parameters, it will be ignored
     * 2. If the parameter type cannot be converted and ignored, throw an error
     * 3. The function name needs to be explicitly given in the error message
     * 4. The numbers in the error message need to use Arabic numerals such as: "3" instead of "three"
     */
    static validateParams(_params) {
        //
    }
    /**
       * @param params The parameter is optional.
       * When the parameter is not passed, the static default type is returned.
       * When passing parameters, different functions dynamically calculate the return type based on the parameter types.
       * Function return type, inferred directly from AstNode, no need to get the actual value
       */
    static getReturnType(params) {
        params && this.validateParams(params);
        return types_1.BasicValueType.String;
    }
    // function body implementation
    static func(_params, _context) { return null; }
}
exports.FormulaFunc = FormulaFunc;
/**
  * The value type that the function parameter can accept.
  * If the parameter type is not in acceptValueType, it will be uniformly converted to string type by the interpreter.
  * If the parameter type is in acceptValueType, the original value will be returned, which will be handled by the function implementation.
  */
FormulaFunc.acceptValueType = new Set([types_1.BasicValueType.Boolean, types_1.BasicValueType.Number, types_1.BasicValueType.String]);
const isArrayTypeParam = (params) => {
    return params.length === 1 && Array.isArray(params[0].value);
};
exports.isArrayTypeParam = isArrayTypeParam;
//# sourceMappingURL=basic.js.map